const messages = {
    enrollments: {
        group: "Группа",
        student: "Ученик",
        showRejected: "Показать отказавшихся",
        showHiddenGroups: "Показывать скрытые группы",
        showNotAddedVk: "Показывать не добавленных VK",
        showNotPaid: "Выделить не доплативших",
        showWasAtMeeting: "Показывать кто был на собрании",
        fully: "полностью",
        noGroups: "В данный момент групп нет",
        deleteGroupConfirmation: "Вы действительно хотите удалить курс \"{0}\"?",
        deleteCommentConfirmation: "Вы действительно хотите удалить комментарий \"{0}\"?",
        deleteEnrollmentConfirmation: "Вы действительно хотите удалить заявку \"{0}\"?",
        deleteDiscountConfirmation: "Вы действительно хотите удалить скидку \"{0}\"?",
        needFillComment: "Необходимо заполнить комментарий",
        contactsAlreadyExist: "Уже есть такие контактные данные: {0}",
        noMessages: "Сообщений нет",
        addToVk: "Добавить в группу VK",
        removeFromVk: "Убрать из группы VK",
        markAsUnderCall: "Пометить как недозвон",
        removeUnderCall: "Убрать недозвон",
        markAsWasAtMeeting: "Был на собрании",
        removeWasAtMeeting: "Не был на собрании",
        comment: "Комментарий к записи",
        fullName: "ФИО",
        nameLabel: "И",
        phone: "Телефон",
        email: "Email",
        vk: "VK",
        source: "Источник",
        test: "Тест",
        payment: "Оплата",
        groupsAreNotLoaded: "Группы пока не загружены. Для загрузки курсов нажмите \"Поиск\" или выберите группу из списков ниже",
        language: "Язык",
        city: "Город",
        vkCityName: "Город VK",
        isMainGroupMember: "Добавлен в общую группу",
        isGroupMember: "Добавлен в группу",
        addedRejected: "Добавлены отказавшиеся",
        addedNotFromGroup: "Добавлены не из группы",
        addedUnknown: "Добавлены неизвестные пользователи",
        company: "Компания",
        messagesTemplates: "Шаблоны сообщений",
        applyTemplate: "Применить шаблон",
        showFromAnotherCities: "Выделить из других городов",
        otherCities: "Другие города",
        hasCompany: "От компании",
        deadline: "Срок досдачи",
        showDeadline: "Показать срок досдачи",
        endDateNotSet: "Не задана дата окончания группы"
    },
    common: {
        search: "Поиск",
        clear: "Очистить",
        confirmDelete: "Подтвердите удаление",
        confirmAdd: "Подтвердите добавление",
        dataSuccessfullyDeleted: "Данные успешно удалены.",
        dataSuccessfullySaved: "Данные успешно сохранены.",
        loading: "Загрузка...",
        unknown: "Неизвестно",
        save: "Сохранить",
        cancel: "Отменить",
        add: "Добавить",
        comment: "Комментарий",
        edit: "Редактировать",
        delete: "Удалить",
        confirm: "Подтвердить",
        unconfirm: "Убрать подтверждение",
        create: "Создать",
        hide: "Скрыть",
        show: "Показать",
        date: "Дата",
        sum: "Сумма",
        ok: "OK",
        close: "Закрыть",
        enterSymbols: "Пожалуйста, введите еще хотя бы {0} символа",
        noMatches: "Совпадений не найдено",
        listEmpty: "Список пуст",
        nMatchesAllowed: "Вы можете выбрать не более {0} элементов",
        roubles: "р.",
        copy: "Скопировать",
        copied: "Скопировано!",
        deleteItem: "Вы действительно хотите удалить эту запись?",
        yes: "Да",
        no: "Нет",
        details: "Подробнее",
        actions: "Действия",
        incorrectUrl: "Некорректный url",
        totalCount: "Общее количество",
        select: "Выбрать",
        applyFilters: "Применить фильтры",
        clearFilters: "Очистить фильтры",
        pageNavigation: "Навигация по страницам",
        toPreviousPage: "На предыдущую страницу",
        toNextPage: "На следующую страницу",
        toFirstPage: "На первую страницу",
        toLastPage: "На последнюю страницу",
        messageTemplateNotSelected: "Шаблон сообщения не выбран",
        messageTemplateNotFound: "Шаблон не найден",
        errorMessageTemplate: "Ошибка в шаблоне сообщения",
        advancedSearch: "Расширенный поиск",
        time: "Время",
        reset: "Сбросить"
    },
    groups: {
        create: "Создание группы",
        edit: "Редактирование группы",
        name: "Название",
        courseType: "Тип курса",
        startDate: "Дата собрания",
        firstLessonDate: "Дата первого занятия",
        lastLessonDate: "Дата последнего занятия",
        endDate: "Дата окончания",
        teacher: "Преподаватель",
        price: "Стоимость",
        downloadExcel: "Выгрузить в Excel",
        downloadExcelForImport: "Экспортировать заявки",
        downloadRecommendationAsExcel: "Скачать рекомендации",
        downloadPaymentsAsExcel: "Выгрузить оплаты в Excel",
        downloadExcelAttendanceForm: "Скачать бланк посещаемости",
        downloadExcelFeedbackForm: "Скачать листок обратной связи",
        total: "Всего:",
        totalOk: "OK:",
        totalThinking: "Думает:",
        totalRejected: "Отказ:",
        totalRejectedByUs: "Наш отказ:",
        totalLookingForSomethingElse: "Искал другое:",
        totalSpam: "Спам:",
        totalUnderCalls: "Недозвон:",
        addEnrollment: "Добавить заявку",
        downloadContracts: "Скачать договоры",
        downloadPdfContracts: "Скачать договоры в PDF",
        downloadCertificates: "Скачать сертификаты",
        lessonsCount: "Количество занятий",
        timetable: "Расписание",
        headTeacher: "Руководитель школы",
        performanceTable: "Таблица успеваемости",
        columnsSettings: "Настройка столбцов",
        needFillVkUrl: "Необходимо заполнить url для VK",
        needFillPerformanceTableUrl: "Необходимо заполнить url для таблицы успеваемости",
        mainChat: "Основной чат",
        additionalChat: "Дополнительный чат",
        downloadGroupList: "Скачать список группы",
        copyGroupListToClipboard: "Скопировать список в буфер обмена",
        synchronizeWithVk: "Синхронизировать с VK",
        synchronize: "Синхронизировать",
        wrongUsersNotFound: "Неправильные пользователи не найдены",
        fullName: "Имя",
        vkUrl: "VK URL",
        groupName: "Название группы",
        groupVkUrl: "URL группы VK",
        removeVkUserReason: "Причина удаления пользователя VK",
        wrongUsers: "Неправильные пользователи",
        synchronized: "Синхронизировано"
    },
    editEnrollments: {
        editTitle: "Редактирование записи на курс",
        createTitle: "Создание записи на курс",
        enrollmentTitle: "Запись на курс",
        language: "Язык программирования",
        enrollmentStatus: "Статус записи",
        recommendationLevel: "Уровень рекомендации",
        recommendation: "Рекомендация",
        firstCommunicationDate: "Дата записи",
        needFillField: "Необходимо заполнить поле",
        underCall: "Недозвон",
        confirmed: "Подтвержден",
        vkAdded: "Добавлен VK",
        hasListenedCourse: "Курс прослушан",
        wasAtMeeting: "Был на собрании",
        hasReview: "Оставил отзыв",
        studentType: "Тип ученика",
        contacts: "Контактные данные",
        firstName: "Имя",
        lastName: "Фамилия",
        middleName: "Отчество",
        hasNotMiddleName: "Нет отчества",
        age: "Возраст",
        gender: "Пол",
        male: "Мужской",
        female: "Женский",
        otherContacts: "Другие контакты",
        rating: "Рейтинг",
        ratingHelp: "1 - максимальный, 4 - минимальный",
        notSpecified: "Нет",
        needContact: "Необходимо заполнить какой-либо контакт",
        communicationHistory: "История коммуникации",
        studentData: "Данные об ученике",
        testType: "Тип теста",
        testResult: "Результат теста",
        noDiscounts: "Скидок нет",
        discountType: "Тип скидки",
        discounts: "Скидки",
        friend: "Друг",
        unusedFriendDiscounts: "Неиспользованные скидки за друзей",
        friendDiscount: "Скидка за друга",
        fromFriendDiscount: "Скидка от друга",
        courseFeedback: "Обратная связь по курсу",
        courseFeedbackPlan: "План обратной связи по курсу",
        contract: "Договор",
        downloadContract: "Скачать договор",
        downloadPdfContract: "Скачать договор в PDF",
        downloadStudentContracts: "Скачать договоры ученика",
        downloadPdfStudentContracts: "Скачать договоры ученика в PDF",
        certificate: "Сертификат",
        downloadCertificate: "Скачать сертификат",
        payerType: "Тип плательщика",
        payerFullName: "ФИО плательщика",
        downloadCertificateWithSignatures: "Скачать сертификат c подписями",
        jobOffers: "Трудоустройство",
        company: "Компания",
        profession: "Профессия",
        programmingArea: "Область программирования",
        internship: "Стажировка",
        jobOfferDate: "Дата предложения работы",
        site: "Сайт",
        comment: "Комментарий",
        vkCityName: "Город VK",
        isGroupMember: "Добавлен в общую группу",
        addedToPublicVkGroup: "Добавлен в общую группу VK",
        didNotCall: "Не созвонились",
        possiblyTesting: "Возможно тестирование",
        callAboutTest: "Созвониться по тесту",
        noTelegram: "Нет Telegram",
        noWhatsApp: "Нет WhatsApp",
        extraTime: "Досдача",
        timeUnit: "Единица времени",
        noExtraTimes: "Нет дополнительной досдачи",
        twoWeeks: "Две недели",
        oneMonth: "Один месяц",
        addFromEmail: "Добавить из письма",
        emailTextOrPhoneNumber: "Текст письма или телефон",
        requiredFieldsAreMissing: "Отсутствуют обязательные поля",
        cyrillicLetters: "Русские буквы не допускаются",
        extraTimeReason: "Причина досдачи",
        birthDate: "Дата рождения",
        resume: "Резюме",
        telegram: "Telegram",
        doNotAddToRecommendations: "Не добавлять в рекомендации",
        overpayment: "Переплата",
        unusedOverpaymentDiscounts: "Неиспользованные скидки за переплату",
        schoolchild: "Школьник",
        student: "Студент",
        offer: "Предложить",
        offerForFriends: "Предложить для друзей",
        doesNotPlan: "Не планирует"
    },
    editPayments: {
        title: "Редактирование оплат",
        price: "Полная стоимость курса:",
        specialPrice: "Специальная цена:",
        specialPriceReason: "Причина специальной цены",
        totalPaid: "Итого оплачено:",
        totalRefunded: "Итого возвращено:",
        totalAmount: "Итоговая сумма:",
        date: "Дата оплаты",
        method: "Способ оплаты",
        discountPrice: "Цена со скидками:",
        friendDiscount: "Скидка за друга ({0}) - {1} р.",
        fromFriendDiscount: "Скидка от друга ({0}) - {1} р.",
        unpaid: "Осталось оплатить:",
        addPayment: "Добавить оплату",
        addRefund: "Добавить возврат",
        payments: "Оплаты",
        refunds: "Возвраты",
        refundDate: "Дата возврата",
        refundMethod: "Способ возврата",
        overpayment: "Переплата:"
    },
    editTestScore: {
        notDone: "не сделано",
        wrong: "неверно",
        title: "Редактирование результатов теста",
        score: "Результаты теста",
        enterDetails: "Ввести подробную информацию",
        clear: "Очистить результаты теста",
        answer: "Ответ:"
    },
    messages: {
        title: "Рассылка сообщений",
        theme: "Тема",
        message: "Сообщение",
        attachFiles: "Прикрепить файлы",
        additionalAddresses: "Дополнительные получатели",
        studentsWithEmails: "Студенты с электронной почтой",
        studentsWithoutEmails: "Студенты без электронной почты",
        studentsWithoutEmailsWithoutVk: "Студенты без электронной почты и без VK",
        sendEmails: "Отправить на email",
        sendVk: "Отправить на VK",
        emailsSending: "Email",
        vkSending: "VK",
        sendingType: "Тип рассылки",
        noAddresses: "Не указан ни один адрес для отправки",
        sendingFailed: "Не удалось отправить письма на следующие адреса:",
        sendingFailedVk: "Не удалось отправить сообщения на следующие адреса VK:",
        sendingStarted: "Отправка писем начата",
        sendingDone: "Письма успешно отправлены",
        vKSendingDone: "Сообщения VK успешно отправлены",
        dropzoneDefaultMessage: "Поместите файлы сюда",
        dropzoneRemoveFile: "Удалить файл",
        dropzoneCancelUpload: "Отменить загрузку",
        uploadingError: "Ошибка при загрузке файла {0}",
        additionalAddressesHelp: "Укажите дополнительные адреса через запятую или точку с запятой",
        additionalVkAddressesHelp: "Укажите дополнительные ссылки на VK через запятую или точку с запятой, например: https://vk.ru/durov",
        filesSizeIsBig: "Суммарный размер файлов не должен превышать 25 мб",
        someFilesLost: "Некоторые прикрепленные файлы потеряны на сервере. Пожалуйста загрузите их снова.",
        enterCaptcha: "Введите код с картинки",
        needCaptcha: "Необходимо ввести капчу",
        clearAfterSending: "Очистить форму после успешной отправки",
        uncheckStudentsWithoutTest: "Убрать студентов без теста"
    },
    signalR: {
        courseGroupCreated: "Пользователь \"{1}\" создал группу \"{0}\"",
        courseGroupCreatedSelf: "Вы создали группу \"{0}\"",
        courseGroupUpdated: "Пользователь \"{1}\" изменил группу \"{0}\"",
        courseGroupUpdatedSelf: "Вы изменили группу \"{0}\"",
        courseGroupDeleted: "Пользователь \"{1}\" удалил группу \"{0}\"",
        courseGroupDeletedSelf: "Вы удалили группу \"{0}\"",
        enrollmentCreated: "Пользователь \"{1}\" создал заявку \"{0}\"",
        enrollmentCreatedSelf: "Вы создали заявку \"{0}\"",
        enrollmentUpdated: "Пользователь \"{1}\" изменил заявку \"{0}\"",
        enrollmentUpdatedSelf: "Вы изменили заявку \"{0}\"",
        enrollmentUpdatedJob: "Заявка \"{0}\" была изменена",
        enrollmentDeleted: "Пользователь \"{1}\" удалил заявку \"{0}\"",
        enrollmentDeletedSelf: "Вы удалили заявку \"{0}\"",
        paymentsUpdated: "Пользователь \"{1}\" изменил платежи по заявке \"{0}\"",
        paymentsUpdatedSelf: "Вы изменили платежи по заявке \"{0}\"",
        testScoreUpdated: "Пользователь \"{1}\" изменил результаты теста у студента \"{0}\"",
        testScoreUpdatedSelf: "Вы изменили результаты теста у студента \"{0}\"",
        feedbackUpdated: "Пользователь \"{1}\" изменил обратную связь у студента \"{0}\"",
        feedbackUpdatedSelf: "Вы изменили обратную связь у студента \"{0}\"",
        messageTemplateCreated: "Шаблон сообщения \"{0}\" был создан",
        messageTemplateUpdated: "Шаблон сообщения \"{0}\" обновлен",
        messageTemplateDeleted: "Шаблон сообщения \"{0}\" удален"
    },
    lastPayments: {
        programming: "Программирование",
        testing: "Тестирование",
        student: "Студент",
        sum: "Сумма",
        paymentType: "Тип платежа",
        totalForPeriod: "Итого за период",
        allPeriodPaymentsSum: "Сумма платежей за период",
        dayPaymentsSum: "Сумма платежей за день",
        cash: "Наличными",
        site: "Через сайт",
        bankTransfer: "Банковским переводом",
        notLoaded: "Не удалось загрузить последние платежи.",
        noPayments: "Нет платежей за последнее время.",
        startDate: "Начальная дата",
        endDate: "Конечная дата",
        date: "Дата",
        dateType: "Тип даты",
        period: "Период",
        dayPaymentsCount: "Количество платежей за день",
        allPeriodPaymentsCount: "Количество платежей за период"
    },
    statistics: {
        startDate: "Начальная дата",
        endDate: "Конечная дата",
        testActive: "Тестирование действующие",
        testFailed: "Тестирование отказавшие",
        programmingActive: "Программирование действующие",
        programmingFailed: "Программирование отказавшие",
        monday: "Пн",
        tuesday: "Вт",
        wednesday: "Ср",
        thursday: "Чт",
        friday: "Пт",
        saturday: "Сб",
        sunday: "Вс",
        total: "Всего",
        notRejectedEnrollmentsCount: "Количество не отказавших заявок",
        profit: "Прибыль",
        noData: "Нет данных",
        profitByMonths: "Прибыль по месяцам",
        profitByYears: "Прибыль по годам",
        profitStatistics: "Статистика по прибыли",
        months: "Месяцы",
        years: "Годы",
        groupsNotFound: "Группы не найдены",
        gender: "Пол",
        men: "Мужчины",
        women: "Женщины",
        notSpecified: "Не указано",
        age: "Возраст",
        city: "Город",
        programmingLanguage: "Язык программирования",
        fromFriend: "От друга",
        source: "Источник",
        enrollmentsStatistics: "Статистика по заявкам",
        newEnrollments: "Новые заявки",
        group: "Группа",
        active: "Активные",
        all: "Все",
        rejected: "Отказавшие",
        enrollmentStatus: "Статус заявки",
        aggregatedStudentSource: "Агрегированный источник",
        needSelectGroup: "Выберите группу",
        noDataForThisGroup: "Нет данных по группе",
        enrollmentsNotFound: "Заявки не найдены",
        "new": "Новые",
        old: "Старые",
        averageAge: "Средний возраст",
        studentType: "Тип ученика"
    },
    courseFeedback: {
        feedback: "Обратная связь",
        feedbackPlan: "План обратной связи",
        editFeedback: "Редактирование обратной связи",
        groupsAreNotLoaded: "Выберите группу",
        editRecommendation: "Редактирование рекомендации",
        showWithoutFeedback: "Показать без обратной связи",
        hideFeedback: "Скрыть обратную связь",
        withoutFeedback: "Без обратной связи",
        listenedCourse: "Прослушали курс",
        strongestRecommendationStudents: "Самые сильные ученики",
        strongRecommendationStudents: "Сильные ученики",
        goodRecommendationStudents: "Хорошие ученики",
        withoutRecommendationStudents: "Без рекомендации",
        successfullyCompletedCourse: "Успешно прошли курс",
        studentsCount: "Количество учеников",
        liked: "Понравилось",
        notLiked: "Не понравилось",
        likedCourse: "Курс понравился",
        didNotLikeCourse: "Курс не понравился",
        willWriteReview: "Отзыв напишет",
        willNotWriteReview: "Отзыв не напишет",
        feedbackNotAsked: "Отзыв не просили",
        noImprovements: "Улучшений нет",
        haveImprovements: "Есть улучшения",
        improvements: "Улучшения",
        time: "Время",
        hoursPerWeek: "Часов в неделю",
        plans: "Планы",
        noPlans: "Планов нет",
        no: "Нет",
        add: "Добавить",
        other: "Прочее",
        winter: "Зимой",
        spring: "Весной",
        summer: "Летом",
        autumn: "Осенью",
        takeCourseAgain: "Повторно",
        thinks: "Думает",
        meetingOnly: "Только собрание",
        ifPassTasks: "Если досдаст",
        ifDoNotPassTasks: "Если не досдаст",
        addToGroups: "Добавить в группы",
        offer: "Предложить",
        groupAlreadySelected: "Группа уже выбрана",
        groupNotSelected: "Группа не выбрана",
        showComment: "Показывать комментарий",
        hasJobOffers: "Есть трудоустрйоство",
        hasCompanies: "От компании",
        doNotAddToRecommendations: "Не добавлять в рекоммендации"
    },
    logs: {
        startTime: "Начальное время",
        endTime: "Конечное время",
        levelsFilter: "Фильтр по уровню",
        level: "Уровень",
        substringInText: "Подстрока в тексте",
        timeColumn: "Время",
        levelColumn: "Уровень",
        textColumn: "Текст",
        noLogs: "Нет ни одной записи, удовлетворяющей параметрам поиска",
        downloadLogs: "Скачать все записи",
        filterAll: "Все уровни",
        filterNotLess: "Уровень >=",
        filterNotHigher: "Уровень <=",
        filterEqual: "Уровень равен",
        caseSensitive: "С учетом регистра"
    },
    rolesManagement: {
        name: "Название роли",
        usersCount: "Кол-во пользователей",
        createRole: "Создать роль",
        editRole: "Редактирование роли",
        deleteRoleConfirmation: "Вы действительно хотите удалить роль \"{0}\"?",
        roleUsers: "Пользователи в роли \"{0}\"",
        userName: "Имя пользователя",
        noRoleUsers: "Нет пользователей с этой ролью",
        deleteUserFromRoleConfirmation: "Вы действительно хотите удалить пользователя \"{0}\" из роли \"{1}\"?",
        addUserToRoleConfirmation: "Вы действительно хотите добавить пользователя \"{0}\" в роль \"{1}\"?"
    },
    usersManagement: {
        name: "Имя пользователя",
        email: "Email",
        userNameOrEmail: "Имя пользователя или email",
        emailConfirmed: "Email подтвержден",
        userDetails: "Подробности о пользователе \"{0}\"",
        phoneNumber: "Номер телефона",
        phoneNumberConfirmed: "Номер телефона подтвержден",
        accessFailedCount: "Количество неудачных попыток входа",
        lockoutEnabled: "Блокировка разрешена",
        isLockedOut: "Заблокирован",
        lockoutEnd: "Блокировка заканчивается",
        twoFactorEnabled: "Двухфакторная аутентификация",
        createUser: "Создать пользователя",
        userRoles: "Роли пользователя",
        rolesOfUser: "Роли пользователя \"{0}\"",
        noUserRoles: "У пользователя нет ролей",
        deleteUserConfirmation: "Вы действительно хотите удалить пользователя \"{0}\"?",
        password: "Пароль",
        confirmPassword: "Подтвердите пароль",
        changePassword: "Сменить пароль",
        changePasswordOfUser: "Изменение пароля пользователя \"{0}\"",
        setLockout: "Установить блокировку",
        setLockoutForUser: "Установить блокировку пользователю \"{0}\"",
        search: "Поиск"
    },
    costCalculation: {
        paymentsSum: "Общая сумма оплат",
        cashPaymentsSum: "Оплачено наличными",
        sitePaymentsSum: "Оплачено через сайт",
        bankTransferPaymentsSum: "Оплачено банковским переводом",
        needToPay: "Осталось оплатить",
        totalCourseCost: "Общая стоимость курса",
        fullPayment: "Полная оплата",
        fullName: "ФИО",
        sum: "Сумма",
        rejected: "Отказавшие",
        notPaidCount: "Количество недоплативших",
        fullPaidRejectedCount: "Количество отказавших в пересчете на людей с полной стоимостью",
        studentsInGroupCount: "Количество учеников в группе",
        rejectedStudentsInGroupCount: "Количество отказавших в группе",
        totalStudentsInGroupCount: "Всего учеников",
        leftToPay: "Осталось оплатить",
        refundsCount: "Количество возвратов",
        refundsSum: "Общая сумма возвратов",
        totalSum: "Общая сумма оплат с учетом возвратов",
        payment: "Оплата",
        refund: "Возврат",
        overpayment: "Переплата",
        overpaymentsSum: "Сумма переплат",
        totalCourseCostTooltip: "Стоимость всех не отказавших заявок + сумма оплат отказавших - сумма возвратов отказавших",
        totalSumTooltip: "Сумма всех оплат - сумма возвратов",
        paymentsSumTooltip: "Сумма всех оплат",
        someCourseHasFullPayment: "Полностью оплачен как минимум один курс", 
        anyCoursesHasNoPayments: "Нет оплаченных курсов",
        partialPaymentCoursesAndEnrollmentNotRejected: "Нет полностью оплаченных курсов, но есть частично оплаченный курс, из группы не удален",
        partialPaymentCoursesAndEnrollmentRejected: "Нет полностью оплаченных курсов, но есть частично оплаченный курс, из группы удален"
    },
    messagesTemplates: {
        tags: "Теги",
        enrollmentId: "Id заявки",
        sourceId: "Id источника",
        addedToVk: "Добавлен VK",
        sourceName: "Название источника",
        courseSubType: "Подтип курса",
        notAnswered: "Не ответил",
        recommendationComment: "Комментарий к рекомендации",
        companyId: "Id компании",
        companyName: "Название компании",
        companySiteUrl: "URL сайта компании",
        companyComment: "Комментерий к компании",
        paymentId: "Id платежа",
        paymentSum: "Сумма платежа",
        refundSum: "Сумма возврата",
        refundType: "Тип возврата",
        studentId: "Id ученика",
        isMale: "Является мужчиной",
        vkUrl: "VK url",
        vkId: "VK id",
        vkScreenName: "Имя VK",
        comments: "Комментарии",
        cityId: "Id города",
        cityName: "Название города",
        novosibirskOffset: "Разница с Новосибирском",
        courseGroupId: "Id группы",
        discountId: "Id скдики",
        discountSum: "Сумма скидки",
        discountComment: "Комментарий к скидке",
        friendId: "Id друга",
        friend: "Друг",
        discountRestriction: "Ограничения скидки",
        percent: "Процент скидки",
        isActiveDiscount: "Скидка активна",
        discountName: "Название скидки",
        extraTimes: "Сроки досдачи",
        extraTimeId: "Id срока досдачи",
        courseGroupText: "Текст группы",
        courseGroupIsHidden: "Группа скрыта",
        courseGroupName: "Название группы",
        name: "Имя тега",
        description: "Описание",
        documentation: "Документация"
    },
    progressTable: {
        tableUrl: "URL таблицы",
        student: "Ученик",
        search: "Поиск",
        students: "Ученики",
        notCompletedTasks: "Не сданы",
        needFillField: "Необходимо заполнить поле",
        lessonsCount: "Количество занятий",
        urlNotSet: "URL не задан",
        tasksCount: "Количество задач",
        totalTasks: "Суммарно задач",
        attendance: "Посещаемость",
        completed: "Сдано",
        partiallyCompleted: "Сдано частично",
        notSent: "Не прислано",
        sent: "Прислано",
        notCompleted: "Не досдано",
        attemptsCountAverage: "Попыток в среднем",
        attended: "Посещено",
        notAttended: "Не посещено",
        comment: "Комментарий"
    },
    taxRefund: {
        student: "Ученик",
        birthDateNotSpecified: "Дата рождения не заполнена",
        year: "Год",
        tin: "ИНН",
        passportSeries: "Серия паспорта",
        passportNumber: "Номер паспорта",
        passportIssueDate: "Дата выдачи паспорта",
        payerDoesNotMatchStudent: "Плательщик не совпадает с учеником",
        firstName: "Имя",
        lastName: "Фамилия",
        middleName: "Отчество",
        birthDate: "Дата рождения",
        downloadCertificate: "Скачать справку",
        payerInfo: "Информация о плательщике",
        correctionNumber: "Номер корректировки",
        studentTin: "ИНН ученика",
        studentPassportSeries: "Серия паспорта",
        studentPassportNumber: "Номер паспорта",
        studentPassportIssueDate: "Дата выдачи паспорта",
        payerTin: "ИНН плательщика",
        payerPassportSeries: "Серия паспорта",
        payerPassportNumber: "Номер паспорта",
        payerPassportIssueDate: "Дата выдачи паспорта",
        noAmountAvailableForRefundForSelectedYear: "Нет суммы для возврата за выбранный год",
        enterPassportDetails: "Внести данные паспорта"
    }
};

export default messages;